import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const SubscribersIcon: React.FC<CardGradientProps> = ({
  className,
  width = "18",
  height = "18",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_2431_13826"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2431_13826)">
        <path
          d="M14.1471 14.2781C14.0783 14.5344 13.9752 14.775 13.8377 15H15.7502C16.1627 15 16.5158 14.8531 16.8096 14.5594C17.1033 14.2656 17.2502 13.9125 17.2502 13.5V12.75C17.2502 12.3875 17.1314 12.0531 16.8939 11.7469C16.6564 11.4406 16.3127 11.1625 15.8627 10.9125C15.3752 10.65 14.8502 10.4281 14.2877 10.2469C13.7252 10.0656 13.1252 9.9375 12.4877 9.8625C13.0502 10.225 13.4846 10.6594 13.7908 11.1656C14.0971 11.6719 14.2502 12.2 14.2502 12.75V13.5C14.2502 13.7625 14.2158 14.0219 14.1471 14.2781Z"
          fill="#FFA686"
        />
        <path
          d="M13.3689 8.11875C13.9564 7.53125 14.2502 6.825 14.2502 6C14.2502 5.175 13.9564 4.46875 13.3689 3.88125C12.7814 3.29375 12.0752 3 11.2502 3C11.0752 3 10.9002 3.00938 10.7252 3.02813C10.5502 3.04688 10.3752 3.0875 10.2002 3.15C10.5377 3.55 10.7971 3.99375 10.9783 4.48125C11.1596 4.96875 11.2502 5.475 11.2502 6C11.2502 6.525 11.1596 7.03125 10.9783 7.51875C10.7971 8.00625 10.5377 8.45 10.2002 8.85C10.3377 8.8875 10.5127 8.92188 10.7252 8.95312C10.9377 8.98438 11.1127 9 11.2502 9C12.0752 9 12.7814 8.70625 13.3689 8.11875Z"
          fill="#FFA686"
        />
        <path
          d="M0.75 12.9C0.75 12.475 0.859375 12.0844 1.07812 11.7281C1.29688 11.3719 1.5875 11.1 1.95 10.9125C2.725 10.525 3.5125 10.2344 4.3125 10.0406C5.1125 9.84687 5.925 9.75 6.75 9.75C7.575 9.75 8.3875 9.84687 9.1875 10.0406C9.9875 10.2344 10.775 10.525 11.55 10.9125C11.9125 11.1 12.2031 11.3719 12.4219 11.7281C12.6406 12.0844 12.75 12.475 12.75 12.9V13.5C12.75 13.9125 12.6031 14.2656 12.3094 14.5594C12.0156 14.8531 11.6625 15 11.25 15H2.25C1.8375 15 1.48438 14.8531 1.19063 14.5594C0.896875 14.2656 0.75 13.9125 0.75 13.5V12.9ZM6.75 9C5.925 9 5.21875 8.70625 4.63125 8.11875C4.04375 7.53125 3.75 6.825 3.75 6C3.75 5.175 4.04375 4.46875 4.63125 3.88125C5.21875 3.29375 5.925 3 6.75 3C7.575 3 8.28125 3.29375 8.86875 3.88125C9.45625 4.46875 9.75 5.175 9.75 6C9.75 6.825 9.45625 7.53125 8.86875 8.11875C8.28125 8.70625 7.575 9 6.75 9Z"
          fill="#CFB2FF"
        />
      </g>
    </svg>
  );
};

export default SubscribersIcon;
